import { setSpecificMessage, finite } from "valibot";
setSpecificMessage(
  finite,
  (issue) => `Entier invalide: reçu ${issue.received}`,
  "fr"
);